/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 */
angular.module('bulbApp.contentEditorModule')

.directive('uploadingFileBlock', uploadingFileBlock);

function uploadingFileBlock() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/contenteditor/uploadingfileblock.html'
  };
}
